var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "selectableItem",
      class: { selectedToolItem: _vm.isSelected },
      on: { click: _vm.selectItem }
    },
    [
      _c(_vm.isSelected ? _vm.filledIcon : _vm.icon, {
        tag: "component",
        staticClass: "toolsSVG",
        class: { filled: _vm.isSelected }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "svgTextToolbar" }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _vm._v(" "),
      _vm.instructions && _vm.isSelected
        ? _c("instructions-tooltip", {
            attrs: { icon: _vm.filledIcon, instructions: _vm.instructions }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52e68944", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e68944","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Toolbars/CreateObjects/ItemStandard.vue
// module id = null
// module chunks = 